import { inResiOrmStore } from "@superbright/indexeddb-orm";

import { apiPaths, queryKeys } from "api/config";
import { inresiHttpService } from "utils/http";
import { queryClient } from "utils/query";

interface SessionResponse {
  data: {
    visitor_uuid: string;
  };
}

export function setVisitorUuidCookie(visitor_uuid: string) {
  // Mirror the IndexedDB visitor_uuid into a cookie so SSR can read it on
  // subsequent requests (enabling server-side bootstrap + listings fetch).
  const maxAge = 365 * 24 * 60 * 60; // 1 year in seconds
  const isSecure = window.location.protocol === "https:";
  // SameSite=None requires Secure (HTTPS). On localhost (HTTP) we fall
  // back to SameSite=Lax so the browser doesn't silently drop the cookie.
  const sameSite = isSecure ? "; SameSite=None; Secure" : "; SameSite=Lax";
  document.cookie = `visitor_uuid=${encodeURIComponent(
    visitor_uuid
  )}; Max-Age=${maxAge}; Path=/${sameSite}`;
}

export async function fetchVisitorSession(
  slug: string,
  vidFromUrl?: string | null
): Promise<string> {
  if (vidFromUrl) {
    await inResiOrmStore.setVisitorUUID(vidFromUrl);
    queryClient.setQueryData(queryKeys.visitorUUID(), vidFromUrl);
    setVisitorUuidCookie(vidFromUrl);
    return vidFromUrl;
  }

  const response = await inresiHttpService.post<SessionResponse>(
    apiPaths.session(slug),
    {}
  );
  const vid = response.data.visitor_uuid;
  await inResiOrmStore.setVisitorUUID(vid);
  queryClient.setQueryData(queryKeys.visitorUUID(), vid);
  setVisitorUuidCookie(vid);
  return vid;
}
